import React from "react";
import { Button, Stack } from "@chakra-ui/react";

const LanguageSwitch = ({ language, toggleLanguage }) => {
  return (
      <Button
        onClick={toggleLanguage}
        colorScheme="green"
        variant="solid"
        color={"white"}
        size={{ base: "sm" }}
        width="50px"
      >
        {language === "english" ? "ES" : "EN"}
    </Button>
  );
};

export default LanguageSwitch;